export default "__VITE_ASSET__rpXDxz3l__"